<template>
  <div
    v-if="true === this.timeState && (hasDefaultSlot || null !== messages)"
    :class="[
      `alert-theme alert-theme--type-${type} alert-theme--size-${size} alert-theme--rounded`,
      {'alert-theme--hoover': hoover},
      {'alert-theme--pointer-up': (/^up/g).exec(pointer)},
      {'alert-theme--pointer-down': (/^down/g).exec(pointer)},
      `alert-theme--pointer-${pointer}`
    ]"
  >
    <img
      v-if="showIcon"
      :src="icons[type]"
      alt=""
      class="alert-theme__icon"
      loading="lazy"
    >
    <div>
      <slot/>
      <template v-if="!hasDefaultSlot && null !== messages">
        <p
          v-if="'string' === typeof messageContainer || 1 === messageContainer.length"
          class="text-left"
        >
          {{ 'string' === typeof messageContainer ? messageContainer : messageContainer[0] }}
        </p>
        <ul
          v-else-if="1 < messageContainer.length"
          class="list-disc ml-3 text-left"
        >
          <li v-for="message in messageContainer">
            {{ message }}
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "adivare-alert",
  props: {
    // messages. A single message (string) or multiple messages (array) are allowed.
    messages: {
      default: null,
      required: false,
      validator: prop => typeof prop === 'object' || typeof prop === 'string' || prop === null,
    },
    // type of message
    type: {
      type: String,
      default: 'danger',
      required: false,
      validator: (value) => {
        return [
          'success',
          'danger',
          'warning',
          'info',
        ].includes(value);
      }
    },
    // show icon
    showIcon: {
      type: Boolean,
      default: false,
      required: false,
    },
    // show message for only X seconds. 0 = disabled
    timer: {
      type: Number,
      default: 0,
      required: false,
    },
    // position alert message in absolute position. Creates hover effect
    hoover: {
      type: Boolean,
      default: false,
      required: false,
    },
    // show pointer.
    // up-(left|middle|right) = pointer above message box. up-left means pointer is oriented upwards in left position
    // down-(left|middle|right) = pointer below message box. down-left means pointer is oriented downwards in left position
    // none = no pointer
    pointer: {
      type: String,
      default: 'none',
      required: false,
      validator: (value) => {
        return [
          'up-left',
          'up-middle',
          'up-right',
          'down-left',
          'down-middle',
          'down-right',
          'none',
        ].includes(value);
      }
    },
    // size of alert message
    size: {
      type: String,
      default: 'md',
      required: false,
      validator: (value) => {
        return [
          'xs',
          'sm',
          'md',
          'lg',
          'xl',
        ].includes(value);
      }
    }
  },
  data() {
    return {
      icons: {
        success: this.$asset('img/common/flashes/grey/success.svg'),
        danger: this.$asset('img/common/flashes/grey/danger.svg'),
        warning: this.$asset('img/common/flashes/grey/warning.svg'),
        info: this.$asset('img/common/flashes/grey/info.svg'),
      },
      timeState: true,
      messageContainer: this.messages,
    }
  },
  watch: {
    messages: {
      handler(message) {
        this.messageContainer = message;
      },
    },
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default
    },
  },
  methods: {
    timeOut() {
      if (0 === this.timer) return;
      setTimeout(() => {
        this.timeState = false;
      }, this.timer * 1000);
    }
  },
  mounted() {
    this.timeOut();
  }
}
</script>
